import React from "react";
import { Route } from "react-router-dom";
import loadable from "@loadable/component";
import ContentLoaderDetail from "@oxygen/core/lib/SkeletonLoader/ContentLoaderDetail";
import { DEALER_LOCATOR_ENDPOINT } from "../Constants/index.desktop";

const DealerLocator = loadable(
  () =>
    import(
      /* webpackChunkName: "dealerlocator-desktop" */ "../Containers/DealerLocator.desktop.js"
    ),
  {
    fallback: <ContentLoaderDetail />,
  }
);
export const DealerLocatorRouteDesktop = (
  <Route
    exact
    path={DEALER_LOCATOR_ENDPOINT}
    render={props => {
      return <DealerLocator {...props} />;
    }}
  />
);
